export function calcDownloadedSize(
  recursive = true,
  win = window,
  result = { transfer: 0, count: 0 },
) {
  const resources = win.performance?.getEntriesByType?.('resource');
  for (const x of resources || []) {
    // note Safari does not report transferSize
    result.transfer += x.transferSize || 0;
    result.count++;
  }

  if (recursive) {
    // can't use for..of to access window[number]
    for (let i = 0; i < win.length; i++) {
      try {
        // try/catch is needed to avoid errors for iframes from different origins.
        calcDownloadedSize(true, win[i], result);
      } catch {
        return null;
      }
    }
  }

  return result;
}
